<template>
    <div>
        <!--  新增&编辑  -->
        <a-drawer
            :title="form.getFieldValue('channel_id') ? $t('submission.edit_channel' /* 编辑渠道 */) : $t('submission.new_channel' /* 新增渠道 */)"
            :visible="visible"
            :confirm-loading="modalLoading"
            :width="1000"
            @close="handleCancel"
        >
            <a-spin :spinning="modalLoading">
                <a-form layout="horizontal" :label-col="{ xs: { span: 24 }, sm: { span: $route.params.lang == 'cn' ? 6 : 8 } }" :wrapper-col="{ xs: { span: 24 }, sm: { span: 16 } }" :form="form">
                    <a-tabs size="small" default-active-key="common">
                        <a-tab-pane key="common" :tab="$t('submission.general_configuration' /* 通用配置 */)">
                            <a-form-item :label="$t('submission.channel_id' /* 渠道ID */)" :hidden="true">
                                <a-input v-decorator="['channel_id']" :placeholder="$t('submission.enter_channel_id' /* 请输入分类ID */)" disabled></a-input>
                            </a-form-item>
                            <a-form-item :label="$t('submission.show_in_left_menu' /* 是否在左侧菜单单独显示 */)" class="mb10">
                                <a-switch
                                    v-decorator="['is_menu', { valuePropName: 'checked', initialValue: false }]"
                                    :checked-children="$t('submission.show' /* 显示 */)"
                                    :un-checked-children="$t('submission.not_show' /* 不显示 */)"
                                />
                            </a-form-item>
                            <a-form-item :label="$t('submission.max_submission_limit' /* 限制每个人最大投稿数量 */)" :extra="$t('submission.default_no_limit' /* 默认数量0为不限制 */)" class="mb10">
                                <a-input-number
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="['abstract_max_num', { initialValue: 0, rules: [{ required: true, message: $t('submission.max_submission_limit' /* 限制每个人最大投稿数量 */) }] }]"
                                    :placeholder="$t('submission.max_submission_limit' /* 限制每个人最大投稿数量 */)"
                                ></a-input-number>
                            </a-form-item>
                            <a-form-item :label="$t('submission.manuscript_language' /* 稿件语言 */)" class="mb10">
                                <a-radio-group
                                    v-decorator="[
                                        'cnen',
                                        { initialValue: 'cn', rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('submission.manuscript_language' /* 稿件语言 */) }] }
                                    ]"
                                >
                                    <a-radio value="cn">{{ $t('web.cn' /* 中文 */) }}</a-radio>
                                    <a-radio value="en">{{ $t('web.en' /* 英文 */) }}</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item :label="$t('submission.collect_other_authors' /* 是否收集其他作者信息 */)" class="mb10">
                                <a-switch
                                    v-decorator="['is_other_author', { valuePropName: 'checked', initialValue: false }]"
                                    :checked-children="$t('formConfig.yes' /* 是 */)"
                                    :un-checked-children="$t('formConfig.no' /* 否 */)"
                                />
                            </a-form-item>
                            <a-form-item :label="$t('submission.collect_corresponding_author' /* 是否收集通讯作者 */)" class="mb10">
                                <a-switch
                                    v-decorator="['is_tongxun_author', { valuePropName: 'checked', initialValue: false }]"
                                    :checked-children="$t('formConfig.yes' /* 是 */)"
                                    :un-checked-children="$t('formConfig.no' /* 否 */)"
                                />
                            </a-form-item>
                            <a-form-item :label="$t('submission.collect_speaking_author' /* 是否收集发言作者 */)" class="mb10">
                                <a-switch
                                    v-decorator="['is_fayan_author', { valuePropName: 'checked', initialValue: false }]"
                                    :checked-children="$t('formConfig.yes' /* 是 */)"
                                    :un-checked-children="$t('formConfig.no' /* 否 */)"
                                />
                            </a-form-item>

                            <a-form-item :label="$t('submission.min_abstract_words' /* 摘要最少字数 */)" class="mb10">
                                <a-input-number
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="[
                                        'min_num',
                                        { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('submission.min_abstract_words' /* 摘要最少字数 */) }] }
                                    ]"
                                    :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('submission.min_abstract_words' /* 摘要最少字数 */)"
                                ></a-input-number>
                            </a-form-item>
                            <a-form-item :label="$t('submission.max_abstract_words' /* 摘要最大字数 */)" class="mb10">
                                <a-input-number
                                    style="width: 100%"
                                    :min="0"
                                    v-decorator="[
                                        'max_num',
                                        { rules: [{ required: true, message: $t('formConfig.please_enter' /* 请输入 */) + $t('submission.max_abstract_words' /* 摘要最大字数 */) }] }
                                    ]"
                                    :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('submission.max_abstract_words' /* 摘要最大字数 */)"
                                ></a-input-number>
                            </a-form-item>
                        </a-tab-pane>
                    </a-tabs>
                    <a-alert type="info" show-icon :message="$t('submission.complete_language_info' /* 请至少完善一个语言信息 */)"></a-alert>
                    <a-tabs size="small" class="mt15" v-model="language">
                        <a-tab-pane key="cn" :tab="$t('web.cn' /* 中文 */)"></a-tab-pane>
                        <a-tab-pane key="en" :tab="$t('web.en' /* 英文 */)"></a-tab-pane>
                    </a-tabs>
                    <div v-show="language == 'cn'">
                        <a-form-item :label="$t('submission.is_open' /* 是否开放 */)" class="mb10">
                            <a-switch
                                v-decorator="['is_open[cn]', { valuePropName: 'checked', initialValue: true }]"
                                :checked-children="$t('web.open' /* 开启 */)"
                                :un-checked-children="$t('web.close' /* 关闭 */)"
                            />
                        </a-form-item>
                        <a-form-item :label="$t('submission.channel_name' /* 渠道名称 */)" class="mb10">
                            <a-input v-decorator="['title[cn]']" :placeholder="$t('submission.channel_name' /* 渠道名称 */)"></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('submission.submission_instructions' /* 投稿须知 */)">
                            <tinymce-editor :height="400" v-decorator="['note[cn]']" :type="2"></tinymce-editor>
                        </a-form-item>
                        <a-form-item :label="$t('submission.show_statement_confirmation' /* 是否开启声明确认 */)" class="mb10">
                            <a-switch
                                v-decorator="['is_show_statement[cn]', { valuePropName: 'checked', initialValue: false }]"
                                :checked-children="$t('web.open' /* 开启 */)"
                                :un-checked-children="$t('web.close' /* 关闭 */)"
                            />
                        </a-form-item>
                        <a-form-item :label="$t('submission.statement_confirmation_title' /* 声明确认标题文字 */)" class="mb10">
                            <a-input
                                v-decorator="['statement_title[cn]']"
                                :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('submission.statement_confirmation_title' /* 声明确认标题文字 */)"
                            ></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('submission.statement_confirmation_details' /* 声明确认详细内容 */)">
                            <tinymce-editor :height="400" v-decorator="['statement_note[cn]']" :type="2"></tinymce-editor>
                        </a-form-item>
                    </div>
                    <div v-show="language == 'en'">
                        <a-form-item :label="$t('submission.is_open' /* 是否开放 */)" class="mb10">
                            <a-switch
                                v-decorator="['is_open[en]', { valuePropName: 'checked', initialValue: false }]"
                                :checked-children="$t('web.open' /* 开启 */)"
                                :un-checked-children="$t('web.close' /* 关闭 */)"
                            />
                        </a-form-item>
                        <a-form-item :label="$t('submission.channel_name' /* 渠道名称 */)" class="mb10">
                            <a-input v-decorator="['title[en]']" :placeholder="$t('submission.channel_name' /* 渠道名称 */)"></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('submission.submission_instructions' /* 投稿须知 */)">
                            <tinymce-editor :height="400" v-decorator="['note[en]']" :type="2"></tinymce-editor>
                        </a-form-item>
                        <a-form-item :label="$t('submission.show_statement_confirmation' /* 是否开启声明确认 */)" class="mb10">
                            <a-switch
                                v-decorator="['is_show_statement[en]', { valuePropName: 'checked', initialValue: false }]"
                                :checked-children="$t('web.open' /* 开启 */)"
                                :un-checked-children="$t('web.close' /* 关闭 */)"
                            />
                        </a-form-item>
                        <a-form-item :label="$t('submission.statement_confirmation_title' /* 声明确认标题文字 */)" class="mb10">
                            <a-input
                                v-decorator="['statement_title[en]']"
                                :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('submission.statement_confirmation_title' /* 声明确认标题文字 */)"
                            ></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('submission.statement_confirmation_details' /* 声明确认详细内容 */)">
                            <tinymce-editor :height="400" v-decorator="['statement_note[en]']" :type="2"></tinymce-editor>
                        </a-form-item>
                    </div>
                </a-form>
            </a-spin>
            <div
                :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="handleCancel">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button type="primary" @click="handleOk">{{ $t('web.submit' /* 提交 */) }}</a-button>
            </div>
        </a-drawer>
    </div>
</template>
<script>
import tinymceEditor from '@/components/Tinymce/index.vue';
import * as judgeType from '@/utils/judgeDataType';
const fields = [
    'channel_id',
    'is_menu',
    'abstract_max_num',
    'cnen',
    'is_tongxun_author',
    'is_fayan_author',
    'is_other_author',
    'min_num',
    'max_num',
    'is_open[cn]',
    'is_open[en]',
    'title[cn]',
    'title[en]',
    'note[cn]',
    'note[en]',
    'is_show_statement[cn]',
    'is_show_statement[en]',
    'statement_title[cn]',
    'statement_title[en]',
    'statement_note[cn]',
    'statement_note[en]'
];
import pick from 'lodash.pick';
export default {
    name: 'UpdateChannelModal',
    components: { tinymceEditor },
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // 分类弹窗
            visible: false,
            modalLoading: false,
            language: 'cn',
            form: this.$form.createForm(this),
            dataInfo: {
                info: {
                    config: {},
                    trans_info: {}
                }
            }
        };
    },
    methods: {
        showFun(channel_id) {
            this.visible = true;
            if (channel_id) {
                this.modalLoading = true;
                this.$request
                    .post({ url: 'getSubmissionChannelInfo', data: { channel_id } })
                    .then(res => {
                        let info = res.data?.info || {};
                        let trans_info = info?.trans_info || {};
                        console.log(trans_info);
                        let fieldData = {
                            ...info?.config,
                            channel_id: info?.channel_id,
                            ['is_open[cn]']: trans_info?.cn?.is_open,
                            ['note[cn]']: trans_info?.cn?.note,
                            ['title[cn]']: trans_info?.cn?.title,
                            ['is_show_statement[cn]']: trans_info?.cn?.is_show_statement,
                            ['statement_title[cn]']: trans_info?.cn?.statement_title,
                            ['statement_note[cn]']: trans_info?.cn?.statement_note,
                            ['is_open[en]']: trans_info?.en?.is_open,
                            ['note[en]']: trans_info?.en?.note,
                            ['title[en]']: trans_info?.en?.title,
                            ['is_show_statement[en]']: trans_info?.en?.is_show_statement,
                            ['statement_title[en]']: trans_info?.en?.statement_title,
                            ['statement_note[en]']: trans_info?.en?.statement_note
                        };

                        for (let key in fieldData) {
                            if (key.startsWith('is_')) {
                                fieldData[key] = fieldData[key] == 1 ? true : false;
                            }
                        }
                        fields.forEach(v => this.form.getFieldDecorator(v));
                        this.form.setFieldsValue(pick(fieldData, fields));
                    })
                    .finally(() => {
                        this.modalLoading = false;
                    });
            }
        },

        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.modalLoading = true;
                    values.is_open.cn = values['is_open']?.cn ? 1 : 0;
                    values.is_open.en = values['is_open']?.en ? 1 : 0;
                    values.is_show_statement.cn = values['is_show_statement']?.cn ? 1 : 0;
                    values.is_show_statement.en = values['is_show_statement']?.en ? 1 : 0;
                    var requestData = {
                        config: {},
                        trans_info: {
                            cn: {},
                            en: {}
                        }
                    };

                    for (let key in values) {
                        // 判断是否为boolean
                        if (judgeType.isBool(values[key])) {
                            values[key] = values[key] ? 1 : 0;
                        }
                        // 判断是否为对象
                        if (judgeType.isObject(values[key])) {
                            requestData.trans_info['cn'][key] = values[key]?.cn;
                            requestData.trans_info['en'][key] = values[key]?.en;
                        } else {
                            requestData.config[key] = values[key];
                        }
                    }
                    requestData = {
                        channel_id: values.channel_id || 0,
                        config: requestData.config,
                        trans_info: requestData.trans_info
                    };
                    this.$request
                        .post({ url: values.channel_id ? 'updateSubmissionChannel' : 'createSubmissionChannel', data: requestData })
                        .then(res => {
                            this.visible = false;
                            this.$message.success('操作成功');
                            this.$emit('success');
                            this.form.resetFields();
                        })
                        .finally(() => {
                            this.modalLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.visible = false;
            this.form.resetFields();
        }
    },
    mounted() {}
};
</script>
<style lang="less" scoped></style>
